import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebar: false,
  },
  getters: {},
  mutations: {
    sidebar(state, bool) {
      state.sidebar = bool;
    },
  },
  actions: {},
  modules: {},
});
